import styled from "styled-components"

export const Wrapper = styled.div`
  background-color: var(--white);
  padding: 16px 16px 7px 10px;
  margin: 10px 0;
  z-index: 2;
`
